import { EmergencyContacts } from "./EmergencyContacts";

export default EmergencyContacts;